import styled from 'styled-components';

export const FlagImage = styled.img`
  width: 30px;
  height: 20px;
`;
